/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compareallfeatures2Inputs */

const en_compareallfeatures2 = /** @type {(inputs: Compareallfeatures2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare all features`)
};

const de_compareallfeatures2 = /** @type {(inputs: Compareallfeatures2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Funktionen vergleichen`)
};

/**
* | output |
* | --- |
* | "Compare all features" |
*
* @param {Compareallfeatures2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const compareallfeatures2 = /** @type {((inputs?: Compareallfeatures2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compareallfeatures2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compareallfeatures2(inputs)
	return de_compareallfeatures2(inputs)
});
export { compareallfeatures2 as "compareAllFeatures" }